export const colorPalette = {
  grey: '#f5f5f5',
  white: '#fff',
  primary: {
    100: '#EEF4FB',
    200: '#D4E5F4',
    300: '#A8CCEB',
    400: '#7DB0E1',
    500: '#5381C1',
    600: '#4A73AD',
    700: '#3D5F8F',
  },
  warning: {
    100: '#FFF7E6',
    200: '#FFEBB3',
    300: '#FFDF80',
    400: '#FFC85D',
    500: '#FFAC33',
    600: '#E6932A',
    700: '#CC7A1F',
    800: '#B36218',
    900: '#994D12',
  },
  success: {
    100: '#E8FBF4',
    200: '#BDF3E0',
    300: '#8DECC9',
    400: '#62E3B3',
    500: '#36D39F',
    600: '#2BB88A',
    700: '#229D75',
    800: '#1A8260',
    900: '#14684C',
  },
  danger: {
    100: '#FEF0F1',
    200: '#FDD1D5',
    300: '#FBB2B9',
    400: '#FA929C',
    500: '#F8727D',
    600: '#E55A66',
    700: '#D1434F',
    800: '#B8303C',
    900: '#9E212B',
  },
};

const theme = {
  token: {
    // colorBgContainer: colorPalette.grey,
    colorPrimary: colorPalette.primary['500'],
    colorWarning: colorPalette.warning['500'],
    colorDanger: colorPalette.danger['500'],
    colorSuccess: colorPalette.success['500'],
    colorTextBase: '#0c0c0c',
    fontFamily: 'Barlow',
    borderRadius: 4,
    fontSize: 14,
    color: { ...colorPalette },
    // colorLink: colorPalette.primary['500'],
    linkHoverColor: colorPalette.primary['700'],
    Button: {
      primaryShadow: 'none',
    },
  },
  components: {
    Segmented: {
      //     itemActiveBg: colorPalette.primary[500],
      //     itemSelectedBg: colorPalette.primary[500],
      itemSelectedColor: '#fff',
      trackBg: '#fff',
      //     itemHoverColor: colorPalette.colorTextBase,
      //     itemHoverBg: colorPalette.primary[200],
    },
  },
};

export default theme;
